import { RootState } from '../store';

export const selectAuthUser = (state: RootState) => state.auth.user;
export const selectAuthToken = (state: RootState) => state.auth.user?.access_token;
export const authSubmitting = (state: RootState) => state.auth.isSubmitting;
export const selectAuthError = (state: RootState) => state.auth.error;
export const authUserLoaded = (state: RootState) => state.auth.loaded;
